import React from 'react';
import {
  GoogleMap,
  MarkerF,
  useJsApiLoader,
  type Libraries,
} from '@react-google-maps/api';
import { Box } from 'src/ui/box';
import { GOOGLE_MAPS_API_KEY } from 'src/utils/google/maps/clientKey';

const GOOGLE_MAPS_LIBRARIES: Libraries = ['geometry'];

type GoogleMapsComponentProps = {
  lat: string;
  lng: string;
};

function GoogleMapComponent({ lat, lng }: GoogleMapsComponentProps) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  //@ts-ignore
  const [, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map: any) {
    // @ts-ignore
    const centerLocation = {
      lat: Number(lat),
      lng: Number(lng),
    };

    const bounds = new window.google.maps.LatLngBounds(centerLocation);
    // @ts-ignore

    const point = {
      lat: Number(lat),
      lng: Number(lng),
    };
    const location = new window.google.maps.LatLng(point);
    bounds.extend(location);
    map.fitBounds(bounds);

    setMap(map);
    // eslint-disable-next-line
  }, []);

  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);

  if (!isLoaded) {
    return <div>loading...</div>;
  }

  return (
    <Box className="h-[300px] w-full">
      <GoogleMap
        zoom={6}
        onLoad={onLoad}
        onUnmount={onUnmount}
        mapContainerStyle={{ height: '100%', width: '100%' }}
        // @ts-ignore
        center={{
          lat: Number(lat),
          lng: Number(lng),
        }}
        options={{
          zoomControl: true,
          streetViewControl: false,
        }}
      >
        <MarkerF
          key={'asdf'}
          icon={{
            path: 'M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z',
            fillColor: '#6cbf31',
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 1,
            anchor: new window.google.maps.Point(0, 20),
          }}
          // @ts-ignore
          position={{
            lat: Number(40.400083),
            lng: Number(-111.851732),
          }}
        ></MarkerF>
      </GoogleMap>
    </Box>
  );
}

export default GoogleMapComponent;
